/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BulkUpdateUnmatchedDataPoints
 */
export interface BulkUpdateUnmatchedDataPoints {
    /**
     * 
     * @type {number}
     * @memberof BulkUpdateUnmatchedDataPoints
     */
    ok: number;
    /**
     * 
     * @type {number}
     * @memberof BulkUpdateUnmatchedDataPoints
     */
    failed: number;
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof BulkUpdateUnmatchedDataPoints
     */
    failures: Array<{ [key: string]: any; }>;
    /**
     * 
     * @type {boolean}
     * @memberof BulkUpdateUnmatchedDataPoints
     */
    failuresTruncated: boolean;
}

/**
 * Check if a given object implements the BulkUpdateUnmatchedDataPoints interface.
 */
export function instanceOfBulkUpdateUnmatchedDataPoints(value: object): value is BulkUpdateUnmatchedDataPoints {
    if (!('ok' in value) || value['ok'] === undefined) return false;
    if (!('failed' in value) || value['failed'] === undefined) return false;
    if (!('failures' in value) || value['failures'] === undefined) return false;
    if ((!('failuresTruncated' in (value as Record<string, any>)) && !('failures_truncated' in (value as Record<string, any>))) || ((value as Record<string, any>)['failuresTruncated'] === undefined && (value as Record<string, any>)['failures_truncated'] === undefined)) return false;
    return true;
}

export function BulkUpdateUnmatchedDataPointsFromJSON(json: any): BulkUpdateUnmatchedDataPoints {
    return BulkUpdateUnmatchedDataPointsFromJSONTyped(json, false);
}

export function BulkUpdateUnmatchedDataPointsFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkUpdateUnmatchedDataPoints {
    if (json == null) {
        return json;
    }
    return {
        
        'ok': json['ok'],
        'failed': json['failed'],
        'failures': json['failures'],
        'failuresTruncated': json['failures_truncated'],
    };
}

export function BulkUpdateUnmatchedDataPointsToJSON(json: any): BulkUpdateUnmatchedDataPoints {
    return BulkUpdateUnmatchedDataPointsToJSONTyped(json, false);
}

export function BulkUpdateUnmatchedDataPointsToJSONTyped(value?: BulkUpdateUnmatchedDataPoints | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ok': value['ok'],
        'failed': value['failed'],
        'failures': value['failures'],
        'failures_truncated': value['failuresTruncated'],
    };
}

